import React from 'react';

import SeriesFrame from '../../images/series-bg.jpg';

export function SeriesImage({
  images,
}: {
  images: (string | null | undefined)[];
}) {
  const validImages = images.filter(
    (img): img is string => typeof img === 'string',
  );

  const [frontImage = SeriesFrame, backImage = SeriesFrame] = validImages;
  return (
    <div className="relative w-[48px] h-[28px] min-w-[48px]">
      <img
        src={backImage}
        alt=""
        draggable="false"
        className="w-full h-[28px] border border-white rounded-[10px] object-cover opacity-50 absolute -top-[5px] left-[5px] rotate-[7deg] z-10"
      />
      <img
        src={frontImage}
        alt=""
        draggable="false"
        className="w-full h-[28px] border border-white rounded-[10px] object-cover absolute top-0 left-0 z-20 shadow-[0px_10px_20px_-5px_rgba(0,0,0,0.1)]"
      />
    </div>
  );
}
